import { HashRouter as Router, Routes, Route, } from "react-router-dom";
import Data from "./components/Data";
import Settings from "./components/Settings";
import AboutUs from "./pages/AboutUs";
import Careers from "./pages/Careers";
import Home from "./pages/Home";
import HowItWorks from "./pages/HowItWorks";
import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";
import NewUser from "./pages/NewUser";
import Privacy from "./pages/Privacy";
import RequestDemo from "./pages/RequestDemo";
import Support from "./pages/Support";
import Terms from "./pages/Terms";
import Thankyou from "./pages/Thankyou";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AboutCandidate from "./components/AboutCandidate";
import Migrations from './pages/Migrations'
import BulkCandidateUp from "./pages/BulkCandidateUp";
import DocUpload from "./pages/DocUpload";
import OfferLetterAcceptance from "./pages/OfferLetterAcceptance";
import { REDIRECTION_LINKS } from "./constants/common";
import { AiAgent } from "./components/drawer/aiAgent/AiAgent";

function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<Login />}></Route>
          <Route path="/support" element={<Support />}></Route>
          <Route path="/terms" element={<Terms />}></Route>
          <Route path="/howitworks" element={<HowItWorks />}></Route>
          <Route path="/thankyou" element={<Thankyou />}></Route>
          <Route path="/request" element={<RequestDemo />}></Route>
          <Route path="/aboutus" element={<AboutUs />}></Route>
          {/* <Route path="/login" element={<Login></Login>}></Route> */}
          <Route path="/resetPassword" element={<ResetPassword></ResetPassword>}></Route>
          <Route path="/home" element={<Home />}></Route>
          <Route path="/data" element={<Data />}></Route>
          <Route path="/forgotPassword" element={<ForgotPassword></ForgotPassword>}></Route>
          <Route path="/privacy" element={<Privacy />}></Route>
          <Route path="/home/job" element={<Home />}></Route>
          <Route path="/help" element={<Home></Home>}></Route>
          <Route path="/careers/:jid/:cid" element={<Careers></Careers>}></Route>
          <Route path="/outreach-application/:jid/:cid" element={<Careers noSource></Careers>}></Route>
          <Route path="/offerletter/:aid/:cid" element={<OfferLetterAcceptance></OfferLetterAcceptance>}></Route>
          <Route path="/home/candidate" element={<Home />}></Route>
          <Route path="/jobs" element={<Home></Home>}></Route>
          <Route path="/jobs/board" element={<Home></Home>}></Route>
          <Route path="/jobs/new" element={<Home></Home>}></Route>
          <Route path="/jobs/candidates" element={<Home></Home>}></Route>
          <Route path="/jobs/candidates/new" element={<Home></Home>}></Route>
          <Route path="/candidates/all" element={<Home />}></Route>
          <Route path="/interviews" element={<Home />}></Route>
          <Route path="/interviews/all" element={<Home></Home>}></Route>
          <Route path="/user" element={<Home></Home>}></Route>
          <Route path="/user/roles" element={<Home></Home>}></Route>
          <Route path="/user/management" element={<Home></Home>}></Route>
          <Route path="/settings" element={<Home />}></Route>
          <Route path="/settings/boards" element={<Home></Home>}></Route>
          <Route path="/settings/profiles" element={<Home />}></Route>
          <Route path="/user/new" element={<Home />}></Route>
          <Route path="/jobs/candidates/about" element={<Home></Home>}></Route>
          <Route path="/jobs/candidates/upload" element={<Home></Home>}></Route>
          <Route path="/jobs/candidates/temp" element={<Home></Home>}></Route>
          <Route path="/docUpload/:aid/:cid" element={<DocUpload></DocUpload>}></Route>
          <Route path="/jobs/candidates/reqEmail" element={<Home></Home>}></Route>
          <Route path="/jobs/candidates/proposal" element={<Home></Home>}></Route>
          <Route path="/jobs/hackerrankdata" element={<Home></Home>}></Route>
          <Route path="/jobs/coderbytedata" element={<Home></Home>}></Route>
          <Route path={REDIRECTION_LINKS.interviewCredits} element={<Home></Home>}></Route>
          <Route path={REDIRECTION_LINKS.outreach} element={<Home></Home>}></Route>
          <Route path={REDIRECTION_LINKS.outreachedJob} element={<Home />}></Route>
          <Route path={REDIRECTION_LINKS.talentPool} element={<Home />}></Route>
        </Routes>
        <AiAgent />
      </Router>
    </div>
  );
}

export default App;
